import { toTitleCase } from '../util/toTitleCase';

import { VALUE_NA, PAYMENT_COMP, PAYMENT_BILLABLE, PAYMENT_UNIT, PAYMENT_FREE } from '../shop/constants';

export const block = (titleId, value, TranslatedCopyComponent, baseClass = '') => ({
  baseClass,
  title: typeof titleId === 'string' ? new TranslatedCopyComponent({ id: titleId }).toString() : titleId,
  value: value || VALUE_NA
});

export const buildAccountName = (accountNum, departments) => {
  const dept = departments.filter(({ customerNumber }) => customerNumber === accountNum)[0];
  if (dept && dept.customerName) return dept.customerName;
  return accountNum || VALUE_NA;
};

export const buildNetTotalHeader = (method, TranslatedCopyComponent) => {
  // Keep priority:  1. UNIT, 2. COMP, 3. BILLABLE, per business request
  // TODO:  Get individual allocations from BE in future
  const found = [PAYMENT_UNIT, PAYMENT_COMP, PAYMENT_BILLABLE].filter(check => method.indexOf(check) !== -1);
  const total = new TranslatedCopyComponent({ id: 'global.total' }).toString();
  if (found.length > 0) return `${toTitleCase(found[0])} ${total}`;
  return total;
};

export const buildNetTotalDisplay = (method, netTotal, currency, getCurrencyComponent) => {
  if (method && method.indexOf(PAYMENT_FREE) !== -1) return toTitleCase(PAYMENT_FREE);
  return netTotal ? getCurrencyComponent(netTotal, currency) : '0';
};

export const buildCartProductTableData = (id, values) => {
  if (!values || Object.keys(values).length === 0) return [];
  return (
    Object.keys(values)
      .filter(val => val.indexOf(id) !== -1 && val.indexOf('purchaseMethod') === -1)
      .map(key => ({
        code: key.split('--')[0],
        quantity: parseInt(values[key], 10)
      })) || []
  );
};

export const buildProductTableData = product => {
  if (!(product && product.crds && product.crds[0] && product.crds[0].sizes)) return [];
  return (
    product.crds[0].sizes.map(size => ({
      code: size.code,
      quantity: size.units
    })) || []
  );
};
